import { render, staticRenderFns } from "./UserProgression.vue?vue&type=template&id=5181412e&scoped=true&"
import script from "./UserProgression.vue?vue&type=script&lang=js&"
export * from "./UserProgression.vue?vue&type=script&lang=js&"
import style0 from "./UserProgression.vue?vue&type=style&index=0&id=5181412e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5181412e",
  null
  
)

export default component.exports